<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import GlowIcon from "@/components/af/GlowIcon/GlowIcon.vue"
import { globalActor } from "@/machines/globalMachine"
import { useLeaveAppModalStore } from "./leaveAppModal.store"
import { storeToRefs } from "pinia"
import { useI18nStore } from "@/stores/i18n"

const { currentLocale } = storeToRefs(useI18nStore())
const { isActive } = storeToRefs(useLeaveAppModalStore())

function onValid() {
  globalActor.send({ type: "GLOBAL.STEPPER.EXIT" })
}
</script>

<template>
  <Dialog v-model:open="isActive">
    <DialogContent
      :class="
        [
          'border-afbranding-border bg-white p-6',
          currentLocale.iso_code_639 === 'ar-SA' && 'arabic',
        ].join(' ')
      "
    >
      <GlowIcon class="mx-auto" icon="fa-thin fa-door-open" />

      <div class="mx-auto w-48">
        <Separator class="bg-grey-lighten-3" />
      </div>

      <DialogTitle class="text-center text-afbranding-heading">
        {{ $t("general.quit.assessment.title") }}
      </DialogTitle>

      <DialogDescription class="text-center text-afbranding-text">
        {{ $t("general.quit.assessment.body") }}
      </DialogDescription>

      <div
        class="-mx-5 flex flex-col items-center justify-center gap-4 px-5 lg:m-0 lg:flex-row lg:px-0"
      >
        <Separator class="bg-grey-lighten-3 lg:hidden" />
        <div class="flex w-full flex-col-reverse gap-4 md:w-auto md:flex-row">
          <DialogClose as-child>
            <Button variant="secondary">{{ $t("general.quit.stay") }}</Button>
          </DialogClose>
          <Button @click="onValid">{{ $t("general.quit.leave") }}</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
